import { createEnv as createEnvCore } from ".";
function createEnv(args) {
  return createEnvCore({
    publicPrefix: "NEXT_PUBLIC_",
    privatePrefix: "",
    isPrivate: args.isPrivate,
    schema: args.schema,
    values: args.values
  });
}
export {
  createEnv
};
//# sourceMappingURL=nextjs.js.map